import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-button-option',
  templateUrl: './button-option.component.html',
  styleUrls: ['./button-option.component.scss']
})
export class ButtonOptionComponent {

  @Input() public options = {
    iconLeft: '',
    iconRight: '',
    isIcon: false,
    listOptions: []
  }

  @Output() public clickAction = new EventEmitter<string>();

  public showModal = false;
  public countOption = 0;

  public openModal(): void {
    this.showModal = !this.showModal;
  }

  public sendOption(data: string, index: number) {
    this.countOption = index;
    this.showModal = false;
    this.clickAction.emit(data);
  }
}